import * as React from 'react';

import { Col, Row } from 'antd';

import { Space } from 'v2/components/Shared/Space';
import useBoolean from 'v2/hooks/useBoolean';

import { FileInput } from '../FileInput';
import { Layout } from '../Layout';
import { Modal } from '../Modal';

function BankReceipt() {
  const [isModalOpen, setModalState] = useBoolean(false);

  return (
    <Layout
      title='Comprovante bancário'
      description='Precisamos que você nos envie uma foto com o número da sua agência e conta, pode ser uma foto do seu cartão ou print do app do seu banco'
    >
      <Row className='-mx-2 my-6' gutter={16}>
        <Col xs={24} sm={20}>
          <FileInput
            name='bank_receipt_image'
            label='Enviar comprovante*'
            validFormats='image/jpeg, image/png, image/jpg, application/pdf'
            helperText={
              <>
                <span
                  id='bank-receipt-image-example-btn'
                  className='text-content-subtitle [&_strong]:text-primary cursor-pointer [&_strong]:font-semibold'
                  role='button'
                  onClick={setModalState.toTrue}
                >
                  Exemplos de comprovantes: <strong>Ver exemplo</strong>
                </span>
                <Space axis='vertical' size={8} />
                <span className='text-primary'>
                  O arquivo deve ter no máximo 2MB e estar no formato .jpg, .jpeg, .png ou .pdf
                </span>
              </>
            }
          />
        </Col>
      </Row>
      <Modal isOpen={isModalOpen} handleClose={setModalState.toFalse}>
        <div className='[&_p]:text-primary flex flex-col gap-4 [&_img]:max-w-full [&_p]:text-2xl [&_p]:font-semibold max-md:[&_svg]:h-fit max-md:[&_svg]:w-full'>
          <p>Print contendo os dados bancários - exemplo</p>
          <img src='/img/bank-receipts.jpg' alt='Comprovantes bancários - exemplo' />
        </div>
      </Modal>
    </Layout>
  );
}

export { BankReceipt };
